export function maskPatientEmail(email: string | null | undefined): string | null {
  if (!email) return null;
  const trimmed = email.trim();
  const at = trimmed.indexOf('@');
  if (at <= 0 || at === trimmed.length - 1) return trimmed;
  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at + 1);
  const dot = domain.lastIndexOf('.');
  if (dot <= 0) return `${local}@${domain.slice(0, 2)}•••••`;
  const head = domain.slice(0, Math.min(2, dot));
  const tld = domain.slice(dot);
  return `${local}@${head}•••••${tld}`;
}
